export default __webpack_public_path__ + "static/media/galoswap logo-02.9fd21112.svg";